export const minzu: any[] = [
    { value: "汉族", label: "汉族" },
    { value: "蒙古族", label: "蒙古族" },
    { value: "回族", label: "回族" },
    { value: "藏族", label: "藏族" },
    { value: "维吾尔族", label: "维吾尔族" },
    { value: "苗族", label: "苗族" },
    { value: "彝族", label: "彝族" },
    { value: "壮族", label: "壮族" },
    { value: "布依族", label: "布依族" },
    { value: "朝鲜族", label: "朝鲜族" },
    { value: "满族", label: "满族" },
    { value: "侗族", label: "侗族" },
    { value: "瑶族", label: "瑶族" },
    { value: "白族", label: "白族" },
    { value: "土家族", label: "土家族" },
    { value: "哈尼族", label: "哈尼族" },
    { value: "哈萨克族", label: "哈萨克族" },
    { value: "傣族", label: "傣族" },
    { value: "黎族", label: "黎族" },
    { value: "傈僳族", label: "傈僳族" },
    { value: "佤族", label: "佤族" },
    { value: "畲族", label: "畲族" },
    { value: "其他", label: "其他" },
];

export const danwei: any[] = [
    '克', '粒', '枚', '片', '只', '个', '尺', '杯', '束', '合', '升', '钱', '两', '包', '支', '盒', '丸'
];

export const yongfa: any[] = [
    "煎服", "炮制", "冲服", "外用适量", "宜入丸散", "生用", "研末用", "内服", "烊化兑服", "煅用", "温水化服", "先煎", "后下", "包煎", "捣汁", "熬膏", "含漱", "吹喉", "研末煎服"
];

export const fuyong: any[] = [
    '日一剂，水煎服', '日一剂，冲服', '日一剂，灌肠', '日一剂，外用', '日一剂，热敷'
];

export const baozhuang: any[] = [
    "灌装", "塑料小包装", '铝箔纸小包装', "千切片小包装"
];

export const jiliangdanwei: any[] = [
    "片/次", '支/次', '包/次', '丸/次', '袋/次', '克/次', '毫克/次', '毫升/次'
];

export const fuyong2: any[] = [
    '口服', '肌注', '外用', '静推', '皮下', '皮内', '腋下', '雾化', '冲洗', '吸入', '穴注', '彭宫', 'B超坐药', '阴道给药', '纳肛', '眼用', '鼻用', '局麻', '含服', '阴道冲洗'
];

export const shijian: any[] = [
    "小时", "日", "日余", "月", "月余", "年", "年余"
];

export const pinci: any[] = [
    "单次", "偶尔", "时常", "经常"
];

export const chengdu: any[] = [
    "轻", "中", "重", "严重"
];
